import type { VertiNodeLocale } from "./VertiNodeLocale.js";

// when adding tenants, make sure to protect their DNS records in the security stack
export enum VertiNodeTenantId {
	cz = "cz",
	eu = "eu",
}

export type VertiNodeTenantizedString = Record<VertiNodeTenantId, string>;

export interface VertiNodeTenant<Id = VertiNodeTenantId> {
	readonly id: Id;
	readonly domain: string;
	readonly locale: VertiNodeLocale;
}
